document.addEventListener('DOMContentLoaded', function() {
    var checkbox = document.getElementById('ship-to-different-address');
    var form = document.getElementById('shipping_form');

    // Function to toggle the active class
    function toggleActiveClass() {
        if (checkbox && checkbox.checked) {
            form.classList.add('active');
        } else if (form) {
            form.classList.remove('active');
        }
    }

    // Only add event listener if checkbox exists
    if (checkbox) {
        // Initial check in case the checkbox is checked by default on page load
        toggleActiveClass();

        // Event listener for changes on the checkbox
        checkbox.addEventListener('change', toggleActiveClass);
    }

    // Get all the select elements within .select-wrapper elements
    var selectWrappers = document.querySelectorAll('.select-wrapper select');

    // Function to add the active class to the parent .select-wrapper
    function addActiveClass() {
        this.parentNode.classList.add('active');
    }

    // Function to remove the active class from the parent .select-wrapper
    function removeActiveClass() {
        this.parentNode.classList.remove('active');
    }

    // Add event listeners to each select element
    selectWrappers.forEach(function(selectElement) {
        selectElement.addEventListener('focus', addActiveClass);
        selectElement.addEventListener('blur', removeActiveClass);
        selectElement.addEventListener('change', removeActiveClass);
    });


});